export default {
  "top.head.title":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "top.head.description":
    "LINK-Jは、三井不動産と産学の有志が中心となって設立した一般社団法人です。医薬関連企業が集積する東京・日本橋エリアを本拠点に、産官学連携によるライフサイエンス領域でのオープンイノベーションを促進し、新産業創造を支援することを目的としています。医学をはじめ、理学や工学、ICTや人工知能といった新たなテクロノジー等、あらゆる科学の複合領域であるライフサイエンス領域において、分野を超えた内外の人的交流・技術交流を促進していきます。",
  "top.recommended.title": "おすすめコンテンツ",
  "top.event.title": "イベント",
  "top.event.list.link": "イベント一覧へ",
  "top.bbt.event.title": "イベント・プログラム",
  "top.bbt.event.list.link": "イベント・プログラム一覧へ",
  "top.news.list.link": "ニュース一覧へ",
  "top.newsletter.head1": "LINK-J",
  "top.newsletter.head2": "最新イベント情報を",
  "top.newsletter.head3": "配信",
  "top.newsletter.link": "イベントお知らせメール登録",
  "top.report.title": "イベントレポート",
  "top.bbt.report.title": "レポート",
  "top.report.list.link": "イベントレポート一覧へ",
  "top.bbt.report.list.link": "レポート一覧へ",
  "top.program.title": "プログラム",
  "top.program.outOfBox.title": "Out of Box相談室",
  "top.program.outOfBox.description":
    "Out of Box相談室は、予約不要・無料で直接相談できる、LINK-J主催の研究成果実用化育成支援プログラムです。",
  "top.program.unikorn.title": "UNIKORN",
  "top.program.unikorn.description":
    "ライフサイエンス分野で事業を展開しているスタートアップの英国/欧州進出を支援します。",
  "top.program.linkBioBay.title": "LINK-BioBAY TOKYO",
  "top.program.linkBioBay.description":
    "国内外のプレーヤーの英知を結集してスタートアップを支援し、グローバルに飛躍する企業を創出します",
  "top.interview.title": "インタビュー・コラム",
  "top.interview.list.link": "インタビュー・コラム一覧へ",
  "top.news.title": "ニュース",
  "top.news.category.all": "すべてを見る",
  "top.bulletinboard.title": "人と情報の交流掲示板",
  "top.bulletinboard.list.link": "人と情報の交流掲示板一覧へ",
  "top.bulletinboard.head1": "Go to LINK-J's",
  "top.bulletinboard.head2": "Bulletin boards",
  "top.aboutUs.title": "LINK-Jを知る",
  "top.aboutUs.linkjMovie.title": "LINK-J Movie",
  "top.aboutUs.linkjMovie.description":
    "LINK-Jはライフサイエンスに関わる人と情報の交流プラットフォームです。",
  "top.aboutUs.chairmanMessage.title": "理事長挨拶",
  "top.aboutUs.chairmanMessage.description":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン　理事長　岡野 栄之",
  "top.aboutUs.oversea.title": "国内外連携",
  "top.aboutUs.oversea.description1": "海外から日本、日本から海外",
  "top.aboutUs.oversea.description2": "双方向の連携でイノベーションを活性化",
  "top.aboutUs.link.why": "Why in Nihonbashi",
  "top.aboutUs.link.west": "What’s LINK-J WEST",
  "top.aboutUs.link.message": "応援メッセージ",
  "top.aboutUs.link.supporter": "サポーター紹介",
  "top.aboutUs.link.company": "事業内容",
  "top.aboutUs.link.organization": "組織概要",
  "top.specialMemberSignUp.title": "特別会員",
  "top.specialMemberSignUp.link.existing": "特別会員について",
  "top.specialMemberSignUp.link.subscription": "入会申し込み",
  "top.specialMemberSignUp.link.list": "特別会員一覧",
  "top.facilities.title": "施設・アクセス",
  "top.facilities.link.room": "ラウンジ・会議室",
  "top.facilities.link.office": "オフィス・ラボ",
  "top.facilities.link.access": "アクセス",
  "top.bbt.head.title":
    "「Blockbuster TOKYO」創薬・医療系スタートアップ育成支援事業｜LINK-J",
  "top.bbt.head.description":
    "「Blockbuster TOKYO」は、製薬企業、支援機関、投資家等が集積する東京の強みを活かし、産学官連携によるオープンイノベーションを加速させるため、創薬・医療領域のスタートアップのロールモデルが持続的に生まれるエコシステムを構築し、自走化を目指していきます。",
} as const;
